import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _omit from 'lodash/omit';
import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveIframe } from '@zillow/zrs-cms';
import { usePlacement } from '../../components/PlacementProvider/PlacementProvider.js';

var _excluded = ["width", "height", "url", "videoId", "autoplay", "muted", "controls", "loop", "color", "fs", "modestbranding", "noCookieDomain", "loading"];
var BlockYoutube = function BlockYoutube(_ref) {
  var attrs = _ref.attrs;
  var _attrs$width = attrs.width,
    width = _attrs$width === void 0 ? 1024 : _attrs$width,
    _attrs$height = attrs.height,
    height = _attrs$height === void 0 ? 768 : _attrs$height;
    attrs.url;
    var videoId = attrs.videoId,
    _attrs$autoplay = attrs.autoplay,
    autoplay = _attrs$autoplay === void 0 ? 0 : _attrs$autoplay,
    _attrs$muted = attrs.muted,
    muted = _attrs$muted === void 0 ? 0 : _attrs$muted,
    _attrs$controls = attrs.controls,
    controls = _attrs$controls === void 0 ? 1 : _attrs$controls,
    _attrs$loop = attrs.loop,
    loop = _attrs$loop === void 0 ? 0 : _attrs$loop,
    color = attrs.color,
    _attrs$fs = attrs.fs,
    fs = _attrs$fs === void 0 ? 1 : _attrs$fs,
    modestbranding = attrs.modestbranding,
    noCookieDomain = attrs.noCookieDomain,
    _attrs$loading = attrs.loading,
    loading = _attrs$loading === void 0 ? 'lazy' : _attrs$loading,
    iframeAttributes = _objectWithoutProperties(attrs, _excluded);
  var domain = noCookieDomain ? 'www.youtube-nocookie.com' : 'www.youtube.com';

  // Create youtube url.
  var embedUrl = new URL("https://" + domain + "/embed/" + videoId);
  embedUrl.searchParams.append('autoplay', autoplay);
  embedUrl.searchParams.append('mute', muted);
  embedUrl.searchParams.append('loop', loop);
  embedUrl.searchParams.append('controls', controls);
  embedUrl.searchParams.append('color', color);
  embedUrl.searchParams.append('modestbranding', modestbranding ? 1 : 0);
  embedUrl.searchParams.append('fs', fs);
  if (color) {
    embedUrl.searchParams.append('color', color);
  }
  if (modestbranding) {
    embedUrl.searchParams.append('modestbranding', modestbranding);
  }
  var isPost = usePlacement() === 'post';
  return /*#__PURE__*/React.createElement(ResponsiveIframe, _extends({
    src: embedUrl.href,
    allowFullScreen: fs,
    loading: loading,
    width: width,
    height: height
  }, _omit(iframeAttributes, 'margin'), isPost ? {
    marginBottom: 'md'
  } : iframeAttributes.margin));
};
BlockYoutube.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    url: PropTypes.string,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    videoId: PropTypes.string,
    autoplay: PropTypes.bool,
    controls: PropTypes.bool,
    loop: PropTypes.bool,
    color: PropTypes.string,
    fs: PropTypes.bool,
    modestbranding: PropTypes.bool,
    noCookieDomain: PropTypes.bool,
    loading: PropTypes.string
  }),
  index: PropTypes.number
} : {};
var Youtube = BlockYoutube;

export { Youtube as default };
